import { orchestrator } from "satcheljs";
import { onCopilotChatDrawerLayoutChange } from "owa-copilot-chat-drawer-store";
import isFlexPaneShownHelper from "owa-app-pane-group-utils/lib/helpers/isFlexPaneShownHelper";
import calculateAvailableWidthBucket from "../utils/calculateAvailableWidthBucket";
import { getAreDisplayAdsEnabled } from "../selectors/getAreDisplayAdsEnabled";
import { setBrowserWidthBucket } from "../actions/setAvailableHeightAndWidthBuckets";
import { onAvailableWidthBucketChanged } from "../actions/onAvailableWidthBucketChanged";
import LayoutChangeSource from "../store/schema/LayoutChangeSource";
import { safeRequestAnimationFrame } from "owa-performance";
import { getActiveDrawerPaneId } from "owa-drawer";
import { newHeaderCapability } from "owa-capabilities-definitions/lib/newHeaderCapability";
import { isCapabilityEnabled } from "owa-capabilities";

/**
 * Helper function to handle layout width changes.
 * This functions calls the appropriate mutators and actions to
 * update the layout based on a width change.
 */
orchestrator(onCopilotChatDrawerLayoutChange, () => {
    safeRequestAnimationFrame(() => {
        updateBrowserWidthBucket();
    });
});

const updateBrowserWidthBucket = () => {
    const activePaneId = isCapabilityEnabled(newHeaderCapability)
        ? getActiveDrawerPaneId()
        : undefined;
    
    const newAvailableWidthBucket = calculateAvailableWidthBucket(false /* skipCache */, getAreDisplayAdsEnabled(), isFlexPaneShownHelper(), activePaneId);
    setBrowserWidthBucket(newAvailableWidthBucket);
    onAvailableWidthBucketChanged(newAvailableWidthBucket, LayoutChangeSource.CopilotChatDrawer);
};
